import { clickedOnLoggedOutPage } from '@bridebook/web/app-basic/lib/analytics/tracking-actions/logged-out-page-click';
import openInBrowser from '@bridebook/web/lib/utils/open-in-browser';
import useHotelPlannerUrl from '@bridebook/web/lib/wedding-website/hotels/use-hotel-planner-url';
import { isHotelsSection } from '@bridebook/web/lib/wedding-website/utils/sections-typeguards';
import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/components/button';
import { SectionContainer } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/components/section-container';
import {
  BodyText,
  Header2,
} from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/components/typography';
import { useWeddingWebsiteData } from '@bridebook/web/components/wedding-website/view-mode/layouts-v2/data/data-context';

export const Hotels = () => {
  const { t } = useTranslation('weddingWebsite');
  const { website, wedding, mainSupplier, isGuestView } = useWeddingWebsiteData();
  const section = website.sections.find(isHotelsSection);
  const dispatch = useDispatch();

  const hotelPlannerUrl = useHotelPlannerUrl({ supplier: mainSupplier, weddingDate: wedding.date });
  const handleHotelPlannerUrlClick = useCallback(() => {
    if (isGuestView) {
      dispatch(
        clickedOnLoggedOutPage({
          clickedLocation: 'weddingWebsites',
          clickedSection: 'placesToStay',
          cta: 'Explore local hotels',
          trackingTarget: 'BigQuery',
        }),
      );
    }
    openInBrowser(hotelPlannerUrl);
  }, [dispatch, hotelPlannerUrl, isGuestView]);

  return (
    <SectionContainer detailsSectionId="hotels" previewSectionId="hotels">
      <Header2>{t('previewMode.tile.hotels.title')}</Header2>
      <BodyText>{section?.data.message}</BodyText>
      <Button onClick={handleHotelPlannerUrlClick}>{t('previewMode.tile.hotels.cta')}</Button>
    </SectionContainer>
  );
};
